const KeyCodeEnum = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SPACE_BAR: 32,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  A: 65
}

export default KeyCodeEnum



// WEBPACK FOOTER //
// ./client/enum/keyCode.js